import React, { useEffect } from "react";
import AdminHeader from "../components/Header/AdminHeader";
import { useDispatch } from "react-redux";
import { showLoader } from "../store/Slices/loaderSlice";

export default function AdminLayout({ Page }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(showLoader());
  }, [dispatch, Page]);
  return (
    <div>
      <AdminHeader />
      <Page />
    </div>
  );
}
